<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
  <path d="m3.5,0h3.5v3h-3.5c-.276,0-.5.225-.5.5v3.5H0v-3.5C0,1.57,1.57,0,3.5,0Zm-.5,9H0v6h3v-6Zm0,8H0v7h7v-3H3v-4Zm18,4h-4v3h7v-7h-3v4Zm0-6h3v-6h-3v6Zm-.5-15h-3.5v3h3.5c.276,0,.5.225.5.5v3.5h3v-3.5c0-1.93-1.57-3.5-3.5-3.5Zm-11.5,3h6V0h-6v3Zm0,21h6v-3h-6v3Z" fill="currentColor"/>
</svg>
